export enum ManualAccessRulesKeyEnum {
  // --- Модуль FRM_AI (ФРМ AI) ---
  // --- Раздел FRM_AI.SECTIONS.MANUAL (Курсы) ---
  FROM_AI_MANUAL_WRITE = 'FROM_AI_MANUAL_WRITE',
  // --- Раздел FRM_AI.SECTIONS.FRM_AI_CHAT (Чат) ---
  FROM_AI_CHAT_WRITE = 'FROM_AI_CHAT_WRITE'
}
